import Vue from "vue";
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
import NProgress from "nprogress";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "/",
      redirect: "login",
      component: () => import("@/layouts/blank-layout/Blanklayout"),
      children: [
        {
          name: "Login",
          path: "login",
          component: () => import("@/views/authentication/Login"),
        },
        {
          name: "Error",
          path: "error",
          component: () => import("@/views/authentication/Error"),
        },
      ],
    },
    {
      path: "/dashboard",

      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          path: "",
          name: "dashboard",
          component: () => import("@/views/StarterPage"),
        },
      ],
    },
    {
      path: "/test",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "TestPage",
          path: "test",
          component: () => import("@/views/test/TestPage"),
        },
      ],
    },
    {
      path: "/promotion",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "PromotionList",
          path: "promotionList",
          component: () => import("@/views/promotion/PromotionListPage"),
        },
        {
          name: "PromotionListFilter",
          path: "promotionList/:filter",
          component: () => import("@/views/promotion/PromotionListPage"),
        },
        {
          name: "CreatePromotion",
          path: "createPromotion",
          component: () => import("@/views/promotion/CreateEditPromotionPage"),
        },
        {
          name: "EditPromotion",
          path: "editPromotion/:id",
          component: () => import("@/views/promotion/CreateEditPromotionPage"),
        },
        {
          name: "DetailsPromotion",
          path: "detailsPromotion/:id",
          component: () => import("@/views/promotion/DetailsPromotionPage.vue"),
        },
      ],
    },
    {
      path: "/raffles",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "RafflesList",
          path: "rafflesList",
          component: () => import("@/views/raffles/RafflesListPage"),
        },
        {
          name: "RafflesListFilter",
          path: "rafflesList/:filter",
          component: () => import("@/views/raffles/RafflesListPage"),
        },
        {
          name: "createRaffles",
          path: "createRaffles",
          component: () => import("@/views/raffles/CreateEditRafflesPage"),
        },
        {
          name: "EditRaffles",
          path: "editRaffles/:id",
          component: () => import("@/views/raffles/CreateEditRafflesPage"),
        },
        {
          name: "DetailsRaffles",
          path: "detailsRaffles/:id",
          component: () => import("@/views/raffles/DetailsRafflesPage.vue"),
        },
      ],
    },
    {
      path: "/loyaltyCampaign",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "LoyaltyCampaignList",
          path: "loyaltyCampaignList",
          component: () => import("@/views/loyaltyCampaign/LoyaltyCampaingListPage.vue"),
        },
        {
          name: "LoyaltyCampaignListFilter",
          path: "loyaltyCampaignList/:filter",
          component: () => import("@/views/loyaltyCampaign/LoyaltyCampaingListPage.vue"),
        },
        {
          name: "createLoyaltyCampaign",
          path: "createLoyaltyCampaign",
          component: () => import("@/views/loyaltyCampaign/CreateEditLoyaltyCampaingPage"),
        },
        {
          name: "EditLoyaltyCampaign",
          path: "editLoyaltyCampaign/:id",
          component: () => import("@/views/loyaltyCampaign/CreateEditLoyaltyCampaingPage"),
        },
        {
          name: "DetailsLoyaltyCampaign",
          path: "detailsLoyaltyCampaign/:id",
          component: () => import("@/views/loyaltyCampaign/DetailsLoyaltyCampaingPage.vue"),
        },
        {
          name: "UsersListLoyaltyCampaign",
          path: "usersListLoyaltyCampaign/:id",
          component: () => import("@/views/loyaltyCampaign/LoyaltyCampaignUsers/LoyaltyCampaingUsersListPage.vue"),
        },
      ],
    },
    {
      path: "/coupon",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CouponList",
          path: "couponList",
          component: () => import("@/views/coupon/CouponListPage"),
        },
        {
          name: "CouponListFilter",
          path: "couponList/:filter",
          component: () => import("@/views/coupon/CouponListPage"),
        },
        {
          name: "CreateCoupon",
          path: "createCoupon",
          component: () => import("@/views/coupon/CreateEditCouponPage"),
        },
        {
          name: "EditCoupon",
          path: "editCoupon/:id",
          component: () => import("@/views/coupon/CreateEditCouponPage"),
        },
        {
          name: "DetailsCoupon",
          path: "detailsCoupon/:id",
          component: () => import("@/views/coupon/DetailsCouponPage"),
        },
      ],
    },
    {
      path: "/user",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "UserList",
          path: "userList",
          component: () => import("@/views/user/UserListPage"),
        },
        {
          name: "CreateUser",
          path: "createUser",
          component: () => import("@/views/user/CreateEditUserPage"),
        },
        {
          name: "EditUser",
          path: "editUser/:id",
          component: () => import("@/views/user/CreateEditUserPage"),
        },
        {
          name: "DetailsUser",
          path: "detailsUser/:id",
          component: () => import("@/views/user/DetailsUserPage"),
        },
      ],
    },
    {
      path: "/group",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "GroupList",
          path: "groupList",
          component: () => import("@/views/group/GroupListPage"),
        },
        {
          name: "CreateGroup",
          path: "createGroup",
          component: () => import("@/views/group/CreateEditGroupPage"),
        },
        {
          name: "EditGroup",
          path: "editGroup/:id",
          component: () => import("@/views/group/CreateEditGroupPage"),
        },
        {
          name: "DetailsGroup",
          path: "detailsGroup/:id",
          component: () => import("@/views/group/DetailsGroupPage"),
        },
      ],
    },
    {
      path: "/coupons",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CouponsList",
          path: "couponsList",
          component: () => import("@/views/coupons/CouponsListPage"),
        },
        {
          name: "CouponsListFilter",
          path: "couponsList/:filter",
          component: () => import("@/views/coupons/CouponsListPage"),
        },
        {
          name: "CreateCoupons",
          path: "createCoupons",
          component: () => import("@/views/coupons/CreateEditCouponsPage"),
        },
        {
          name: "EditCoupons",
          path: "editCoupons/:id",
          component: () => import("@/views/coupons/CreateEditCouponsPage"),
        },
        {
          name: "DetailsCoupons",
          path: "detailsCoupons/:id",
          component: () => import("@/views/coupons/DetailsCouponsPage"),
        },
        {
          name: "CouponsListNoAffiliate",
          path: "noAffiliate/couponsList",
          component: () =>
            import("@/views/coupons/noAffiliate/CouponsListPage"),
        },
        {
          name: "CouponsListFilterNoAffiliate",
          path: "noAffiliate/couponsList/:filter",
          component: () =>
            import("@/views/coupons/noAffiliate/CouponsListPage"),
        },
        {
          name: "CreateCouponsNoAffiliate",
          path: "noAffiliate/createCoupons",
          component: () =>
            import("@/views/coupons/noAffiliate/CreateEditCouponsPage"),
        },
        {
          name: "EditCouponsNoAffiliate",
          path: "noAffiliate/editCoupons/:id",
          component: () =>
            import("@/views/coupons/noAffiliate/CreateEditCouponsPage"),
        },
        {
          name: "DetailsCouponsNoAffiliate",
          path: "noAffiliate/detailsCoupons/:id",
          component: () =>
            import("@/views/coupons/noAffiliate/DetailsCouponsPage"),
        },
      ],
    },
    {
      path: "/company",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CompanyList",
          path: "companyList",
          component: () => import("@/views/company/CompanyListPage"),
        },
        {
          name: "CreateCompany",
          path: "createCompany",
          component: () => import("@/views/company/CreateEditCompanyPage"),
        },
        {
          name: "EditCompany",
          path: "editCompany/:id",
          component: () => import("@/views/company/CreateEditCompanyPage"),
        },
        {
          name: "DetailsCompany",
          path: "detailsCompany/:id",
          component: () => import("@/views/company/DetailsCompanyPage"),
        },
        {
          name: "CompanyListNoAffiliate",
          path: "noAffiliate/companyList",
          component: () =>
            import("@/views/company/noAffiliate/CompanyListPage"),
        },
        {
          name: "CreateCompanynoAffiliate",
          path: "noAffiliate/createCompany",
          component: () =>
            import("@/views/company/noAffiliate/CreateEditCompanyPage"),
        },
        {
          name: "EditCompanynoAffiliate",
          path: "noAffiliate/editCompany/:id",
          component: () =>
            import("@/views/company/noAffiliate/CreateEditCompanyPage"),
        },
        {
          name: "DetailsCompanynoAffiliate",
          path: "noAffiliate/detailsCompany/:id",
          component: () =>
            import("@/views/company/noAffiliate/DetailsCompanyPage"),
        },
      ],
    },
    {
      path: "/branchOffice",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "BranchOfficeList",
          path: "branchOfficeList",
          component: () => import("@/views/branchOffice/BranchOfficeListPage"),
        },
        {
          name: "CreateBranchOffice",
          path: "createBranchOffice",
          component: () =>
            import("@/views/branchOffice/CreateEditBranchOfficePage"),
        },
        {
          name: "EditBranchOffice",
          path: "editBranchOffice/:id",
          component: () =>
            import("@/views/branchOffice/CreateEditBranchOfficePage"),
        },
        {
          name: "DetailsBranchOffice",
          path: "detailsBranchOffice/:id",
          component: () =>
            import("@/views/branchOffice/DetailsBranchOfficePage"),
        },
        {
          name: "BranchOfficeListNoAffiliate",
          path: "noAffiliate/branchOfficeList",
          component: () =>
            import("@/views/branchOffice/noAffiliate/BranchOfficeListPage"),
        },
        {
          name: "CreateBranchOfficeNoAffiliate",
          path: "noAffiliate/createBranchOffice",
          component: () =>
            import(
              "@/views/branchOffice/noAffiliate/CreateEditBranchOfficePage"
            ),
        },
        {
          name: "EditBranchOfficeNoAffiliate",
          path: "noAffiliate/editBranchOffice/:id",
          component: () =>
            import(
              "@/views/branchOffice/noAffiliate/CreateEditBranchOfficePage"
            ),
        },
        {
          name: "DetailsBranchOfficeNoAffiliate",
          path: "noAffiliate/detailsBranchOffice/:id",
          component: () =>
            import("@/views/branchOffice/noAffiliate/DetailsBranchOfficePage"),
        },
      ],
    },
    {
      path: "/category",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CategoryList",
          path: "categoryList",
          component: () => import("@/views/category/CategoryListPage"),
        },
        {
          name: "CreateCategory",
          path: "createCategory",
          component: () => import("@/views/category/CreateEditCategoryPage"),
        },
        {
          name: "EditCategory",
          path: "editCategory/:id",
          component: () => import("@/views/category/CreateEditCategoryPage"),
        },
        {
          name: "DetailsCategory",
          path: "detailsCategory/:id",
          component: () => import("@/views/category/DetailsCategoryPage"),
        },
      ],
    },
    {
      path: "/payment",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "PaymentList",
          path: "paymentList",
          component: () => import("@/views/payment/PaymentListPage"),
        },
        {
          name: "DetailsPayment",
          path: "detailsPayment/:id",
          component: () => import("@/views/payment/DetailsPaymentPage"),
        },
      ],
    },
    {
      path: "/order",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "OrderList",
          path: "orderList",
          component: () => import("@/views/order/OrderListPage"),
        },
        {
          name: "OrderListFilter",
          path: "orderList/:filter",
          component: () => import("@/views/order/OrderListPage"),
        },
        {
          name: "DetailsOrder",
          path: "detailsOrder/:id",
          component: () => import("@/views/order/DetailsOrderPage"),
        },
      ],
    },
    {
      path: "/couponUse",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CouponUseList",
          path: "couponUseList",
          component: () => import("@/views/couponUse/CouponUseListPage"),
        },
        {
          name: "CouponUseListFilter",
          path: "couponUseList/:filter",
          component: () => import("@/views/couponUse/CouponUseListPage"),
        },
        {
          name: "DetailsCouponUse",
          path: "detailsCouponUse/:id",
          component: () => import("@/views/couponUse/DetailsCouponUsePage"),
        },
      ],
    },
    {
      path: "/employment",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "EmploymentList",
          path: "employmentList",
          component: () => import("@/views/employment/EmploymentListPage"),
        },
        {
          name: "CreateEmployment",
          path: "createEmployment",
          component: () =>
            import("@/views/employment/CreateEditEmploymentPage"),
        },
        {
          name: "EditEmployment",
          path: "editEmployment/:id",
          component: () =>
            import("@/views/employment/CreateEditEmploymentPage"),
        },
        {
          name: "EmploymentUse",
          path: "detailsEmployment/:id",
          component: () => import("@/views/employment/DetailsEmploymentPage"),
        },
        {
          name: "EmploymentListNoAffiliate",
          path: "noAffiliate/employmentList",
          component: () =>
            import("@/views/employment/noAffiliate/EmploymentListPage"),
        },
        {
          name: "CreateEmploymentNoAffiliate",
          path: "noAffiliate/createEmployment",
          component: () =>
            import("@/views/employment/noAffiliate/CreateEditEmploymentPage"),
        },
        {
          name: "EditEmploymentNoAffiliate",
          path: "noAffiliate/editEmployment/:id",
          component: () =>
            import("@/views/employment/noAffiliate/CreateEditEmploymentPage"),
        },
        {
          name: "EmploymentUseNoAffiliate",
          path: "noAffiliate/detailsEmployment/:id",
          component: () =>
            import("@/views/employment/noAffiliate/DetailsEmploymentPage"),
        },
      ],
    },
    {
      path: "/manager",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "ManagerList",
          path: "managerList",
          component: () => import("@/views/manager/ManagerListPage"),
        },
        {
          name: "CreateManager",
          path: "createManager",
          component: () => import("@/views/manager/CreateEditManagerPage"),
        },
        {
          name: "EditManager",
          path: "editManager/:id",
          component: () => import("@/views/manager/CreateEditManagerPage"),
        },
        {
          name: "DetailsManager",
          path: "detailsManager/:id",
          component: () => import("@/views/manager/DetailsManagerPage"),
        },
        {
          name: "ManagerListNoAffiliate",
          path: "noAffiliate/managerList",
          component: () =>
            import("@/views/manager/noAffiliate/ManagerListPage"),
        },
        {
          name: "CreateManagerNoAffiliate",
          path: "noAffiliate/createManager",
          component: () =>
            import("@/views/manager/noAffiliate/CreateEditManagerPage"),
        },
        {
          name: "EditManagerNoAffiliate",
          path: "noAffiliate/editManager/:id",
          component: () =>
            import("@/views/manager/noAffiliate/CreateEditManagerPage"),
        },
        {
          name: "DetailsManagerNoAffiliate",
          path: "noAffiliate/detailsManager/:id",
          component: () =>
            import("@/views/manager/noAffiliate/DetailsManagerPage"),
        },
      ],
    },
    {
      path: "/country",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CountryList",
          path: "countryList",
          component: () => import("@/views/country/CountryListPage"),
        },
        {
          name: "CreateCountry",
          path: "createCountry",
          component: () => import("@/views/country/CreateEditCountryPage"),
        },
        {
          name: "EditCountry",
          path: "editCountry/:id",
          component: () => import("@/views/country/CreateEditCountryPage"),
        },
        {
          name: "DetailsCountry",
          path: "detailsCountry/:id",
          component: () => import("@/views/country/DetailsCountryPage"),
        },
      ],
    },
    {
      path: "/region",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "RegionList",
          path: "regionList",
          component: () => import("@/views/region/RegionListPage"),
        },
        {
          name: "CreateRegion",
          path: "createRegion",
          component: () => import("@/views/region/CreateEditRegionPage"),
        },
        {
          name: "EditRegion",
          path: "editRegion/:id",
          component: () => import("@/views/region/CreateEditRegionPage"),
        },
        {
          name: "DetailsRegion",
          path: "detailsRegion/:id",
          component: () => import("@/views/region/DetailsRegionPage"),
        },
      ],
    },
    {
      path: "/city",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CityList",
          path: "cityList",
          component: () => import("@/views/city/CityListPage"),
        },
        {
          name: "CreateCity",
          path: "createCity",
          component: () => import("@/views/city/CreateEditCityPage"),
        },
        {
          name: "EditCity",
          path: "editCity/:id",
          component: () => import("@/views/city/CreateEditCityPage"),
        },
        {
          name: "DetailsCity",
          path: "detailsCity/:id",
          component: () => import("@/views/city/DetailsCityPage"),
        },
      ],
    },

    {
      path: "/commercial",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CommercialList",
          path: "commercialList",
          component: () => import("@/views/commercial/CommercialListPage"),
        },
        {
          name: "CreateCommercial",
          path: "createCommercial",
          component: () =>
            import("@/views/commercial/CreateEditCommercialPage"),
        },
        {
          name: "EditCommercial",
          path: "editCommercial/:id",
          component: () =>
            import("@/views/commercial/CreateEditCommercialPage"),
        },
        {
          name: "DetailsCommercial",
          path: "detailsCommercial/:id",
          component: () => import("@/views/commercial/DetailsCommercialPage"),
        },
      ],
    },
    {
      path: "/feedback",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "FeedbackList",
          path: "feedbackList",
          component: () => import("@/views/feedback/FeedbackListPage"),
        },
        {
          name: "DetailsFeedback",
          path: "detailsFeedback/:id",
          component: () => import("@/views/feedback/DetailsFeedbackPage"),
        },
      ],
    },
    {
      path: "/maintenance",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "MaintenanceList",
          path: "maintenanceList",
          component: () => import("@/views/maintenance/MaintenanceListPage"),
        },
        {
          name: "CreateMaintenance",
          path: "createMaintenance",
          component: () =>
            import("@/views/maintenance/CreateEditMaintenancePage"),
        },
        {
          name: "EditMaintenance",
          path: "editMaintenance/:id",
          component: () =>
            import("@/views/maintenance/CreateEditMaintenancePage"),
        },
        {
          name: "DetailsMaintenance",
          path: "detailsMaintenance/:id",
          component: () => import("@/views/maintenance/DetailsMaintenancePage"),
        },
      ],
    },
    {
      path: "/version",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "VersionList",
          path: "versionList",
          component: () => import("@/views/version/VersionListPage"),
        },
        {
          name: "CreateVersion",
          path: "createVersion",
          component: () => import("@/views/version/CreateEditVersionPage"),
        },
        {
          name: "EditVersion",
          path: "editVersion/:id",
          component: () => import("@/views/version/CreateEditVersionPage"),
        },
        {
          name: "DetailsVersion",
          path: "detailsVersion/:id",
          component: () => import("@/views/version/DetailsVersionPage"),
        },
      ],
    },
    {
      path: "/clientType",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "ClientTypeList",
          path: "clientTypeList",
          component: () => import("@/views/clientType/ClientTypeListPage"),
        },
        {
          name: "CreateClientType",
          path: "createClientType",
          component: () =>
            import("@/views/clientType/CreateEditClientTypePage"),
        },
        {
          name: "EditClientType",
          path: "editClientType/:id",
          component: () =>
            import("@/views/clientType/CreateEditClientTypePage"),
        },
        {
          name: "DetailsClientType",
          path: "detailsClientType/:id",
          component: () => import("@/views/clientType/DetailsClientTypePage"),
        },
      ],
    },
    {
      path: "/service",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "ServiceList",
          path: "serviceList",
          component: () => import("@/views/service/ServiceListPage"),
        },
        {
          name: "CreateService",
          path: "createService",
          component: () => import("@/views/service/CreateEditServicePage"),
        },
        {
          name: "EditService",
          path: "editService/:id",
          component: () => import("@/views/service/CreateEditServicePage"),
        },
        {
          name: "DetailsService",
          path: "detailsService/:id",
          component: () => import("@/views/service/DetailsServicePage"),
        },
      ],
    },
    {
      path: "/deal",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "DealList",
          path: "dealList",
          component: () => import("@/views/deal/DealListPage"),
        },
        {
          name: "CreateDeal",
          path: "createDeal",
          component: () => import("@/views/deal/CreateEditDealPage"),
        },
        {
          name: "EditDeal",
          path: "editDeal/:id",
          component: () => import("@/views/deal/CreateEditDealPage"),
        },
        {
          name: "DetailsDeal",
          path: "detailsDeal/:id",
          component: () => import("@/views/deal/DetailsDealPage"),
        },
      ],
    },
    {
      path: "/subCategoryDesc",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "SubCategoryDescList",
          path: "subCategoryDescList",
          component: () =>
            import("@/views/subCategoryDesc/SubCategoryDescListPage"),
        },
        {
          name: "CreateSubCategoryDesc",
          path: "createSubCategoryDesc",
          component: () =>
            import("@/views/subCategoryDesc/CreateEditSubCategoryDescPage"),
        },
        {
          name: "EditSubCategoryDesc",
          path: "editSubCategoryDesc/:id",
          component: () =>
            import("@/views/subCategoryDesc/CreateEditSubCategoryDescPage"),
        },
        {
          name: "DetailsSubCategoryDesc",
          path: "detailsSubCategoryDesc/:id",
          component: () =>
            import("@/views/subCategoryDesc/DetailsSubCategoryDescPage"),
        },
      ],
    },
    {
      path: "/couponOff",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CouponOffList",
          path: "couponOffList",
          component: () => import("@/views/couponOff/CouponOffListPage"),
        },
        {
          name: "CreateCouponOff",
          path: "createCouponOff",
          component: () => import("@/views/couponOff/CreateEditCouponOffPage"),
        },
        {
          name: "EditCouponOff",
          path: "editCouponOff/:id",
          component: () => import("@/views/couponOff/CreateEditCouponOffPage"),
        },
        {
          name: "DetailsCouponOff",
          path: "detailsCouponOff/:id",
          component: () => import("@/views/couponOff/DetailsCouponOffPage"),
        },
      ],
    },
    {
      path: "/notificationBody",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "NotificationBodyList",
          path: "notificationBodyList",
          component: () =>
            import("@/views/notificationBody/NotificationBodyListPage"),
        },
        {
          name: "CreateNotificationBody",
          path: "createNotificationBody",
          component: () =>
            import("@/views/notificationBody/CreateEditNotificationBodyPage"),
        },
        {
          name: "EditNotificationBody",
          path: "editNotificationBody/:id",
          component: () =>
            import("@/views/notificationBody/CreateEditNotificationBodyPage"),
        },
        {
          name: "DetailsNotificationBody",
          path: "detailsNotificationBody/:id",
          component: () =>
            import("@/views/notificationBody/DetailsNotificationBodyPage"),
        },
      ],
    },
    {
      path: "/notification",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "list",
          path: "list",
          component: () => import("@/views/notification/NotificationListPage"),
        },
        {
          name: "send",
          path: "send",
          component: () => import("@/views/notification/SendNotificationPage"),
        },
        {
          name: "details",
          path: "details/:id",
          component: () =>
            import("@/views/notification/DetailsNotificationPage"),
        },
      ],
    },
    {
      path: "/globalConfiguration",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "GlobalConfigurationList",
          path: "globalConfigurationList",
          component: () =>
            import("@/views/globalConfiguration/GlobalConfigurationListPage"),
        },
        {
          name: "CreateEditGlobalConfiguration",
          path: "createEditGlobalConfiguration",
          component: () =>
            import(
              "@/views/globalConfiguration/CreateEditGlobalConfigurationPage"
            ),
        },
        {
          name: "EditGlobalConfiguration",
          path: "editGlobalConfiguration/:id",
          component: () =>
            import(
              "@/views/globalConfiguration/CreateEditGlobalConfigurationPage"
            ),
        },
        // {
        //   name: "details",
        //   path: "details/:id",
        //   component: () => import("@/views/notification/DetailsNotificationPage"),
        // },
      ],
    },
    {
      path: "/couponWelcome",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CouponWelcomeList",
          path: "couponWelcomeList",
          component: () =>
            import("@/views/couponWelcome/CouponWelcomeListPage"),
        },
        // {
        //   name: "CouponListFilter",
        //   path: "couponList/:filter",
        //   component: () => import("@/views/coupon/CouponListPage"),
        // },
        {
          name: "CreateCouponWelcome",
          path: "createCouponWelcome",
          component: () =>
            import("@/views/couponWelcome/CreateEditCouponWelcomePage"),
        },
        {
          name: "EditCouponWelcome",
          path: "editCouponWelcome/:id",
          component: () =>
            import("@/views/couponWelcome/CreateEditCouponWelcomePage"),
        },
        {
          name: "DetailsCouponWelcome",
          path: "detailsCouponWelcome/:id",
          component: () =>
            import("@/views/couponWelcome/DetailsCouponWelcomePage"),
        },
      ],
    },
    {
      path: "/couponReference",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CouponReferenceList",
          path: "couponReferenceList",
          component: () =>
            import("@/views/couponReference/CouponReferenceListPage"),
        },
        // {
        //   name: "CouponListFilter",
        //   path: "couponList/:filter",
        //   component: () => import("@/views/coupon/CouponListPage"),
        // },
        {
          name: "CreateCouponReference",
          path: "createCouponReference",
          component: () =>
            import("@/views/couponReference/CreateEditCouponReferencePage"),
        },
        {
          name: "EditCouponReference",
          path: "editCouponReference/:id",
          component: () =>
            import("@/views/couponReference/CreateEditCouponReferencePage"),
        },
        {
          name: "DetailsCouponReference",
          path: "detailsCouponReference/:id",
          component: () =>
            import("@/views/couponReference/DetailsCouponReferencePage"),
        },
      ],
    },
    {
      path: "/couponReferer",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CouponRefererList",
          path: "couponRefererList",
          component: () =>
            import("@/views/couponReferer/CouponRefererListPage"),
        },
        // {
        //   name: "CouponListFilter",
        //   path: "couponList/:filter",
        //   component: () => import("@/views/coupon/CouponListPage"),
        // },
        {
          name: "CreateCouponReferer",
          path: "createCouponReferer",
          component: () =>
            import("@/views/couponReferer/CreateEditCouponRefererPage"),
        },
        {
          name: "EditCouponReferer",
          path: "editCouponReferer/:id",
          component: () =>
            import("@/views/couponReferer/CreateEditCouponRefererPage"),
        },
        {
          name: "DetailsCouponReferer",
          path: "detailsCouponReferer/:id",
          component: () =>
            import("@/views/couponReferer/DetailsCouponRefererPage"),
        },
      ],
    },
    {
      path: "/couponWelcomeUser",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CouponWelcomeUserList",
          path: "couponWelcomeUserList",
          component: () =>
            import("@/views/couponWelcomeUser/CouponWelcomeUserListPage"),
        },
        {
          name: "DetailsCouponWelcomeUser",
          path: "detailsCouponWelcomeUser/:id",
          component: () =>
            import("@/views/couponWelcomeUser/DetailsCouponWelcomeUserPage"),
        },
      ],
    },
    {
      path: "/couponReferenceUser",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CouponReferenceUserList",
          path: "couponReferenceUserList",
          component: () =>
            import("@/views/couponReferenceUser/CouponReferenceUserListPage"),
        },
        {
          name: "DetailsCouponReferenceUser",
          path: "detailsCouponReferenceUser/:id",
          component: () =>
            import(
              "@/views/couponReferenceUser/DetailsCouponReferenceUserPage"
            ),
        },
      ],
    },
    {
      path: "/couponRefererUser",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "CouponRefererUserList",
          path: "couponRefererUserList",
          component: () =>
            import("@/views/couponRefererUser/CouponRefererUserListPage"),
        },
        {
          name: "DetailsCouponRefererUser",
          path: "detailsCouponRefererUser/:id",
          component: () =>
            import("@/views/couponRefererUser/DetailsCouponRefererUserPage"),
        },
      ],
    },
    {
      path: "/meta",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "MetaList",
          path: "metaList",
          component: () => import("@/views/meta/MetaListPage"),
        },
        {
          name: "CreateMeta",
          path: "createMeta",
          component: () => import("@/views/meta/CreateEditMetaPage"),
        },
        {
          name: "EditMeta",
          path: "editMeta/:id",
          component: () => import("@/views/meta/CreateEditMetaPage"),
        },
        {
          name: "DetailsMeta",
          path: "detailsMeta/:id",
          component: () => import("@/views/meta/DetailsMetaPage"),
        },
      ],
    },
    {
      path: "/metaGroup",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "MetaGroupList",
          path: "metaGroupList",
          component: () => import("@/views/metaGroup/MetaGroupListPage"),
        },
        {
          name: "CreateMetaGroup",
          path: "createMetaGroup",
          component: () => import("@/views/metaGroup/CreateEditMetaGroupPage"),
        },
        {
          name: "EditMetaGroup",
          path: "editMetaGroup/:id",
          component: () => import("@/views/metaGroup/CreateEditMetaGroupPage"),
        },
        {
          name: "DetailsMetaGroup",
          path: "detailsMetaGroup/:id",
          component: () => import("@/views/metaGroup/DetailsMetaGroupPage"),
        },
      ],
    },
    {
      path: "/metaSeller",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "MetaSellerList",
          path: "metaSellerList",
          component: () => import("@/views/metaSeller/MetaSellerListPage"),
        },
        {
          name: "CreateMetaSeller",
          path: "createMetaSeller",
          component: () =>
            import("@/views/metaSeller/CreateEditMetaSellerPage"),
        },
        {
          name: "EditMetaSeller",
          path: "editMetaSeller/:id",
          component: () =>
            import("@/views/metaSeller/CreateEditMetaSellerPage"),
        },
        {
          name: "DetailsMetaSeller",
          path: "detailsMetaSeller/:id",
          component: () => import("@/views/metaSeller/DetailsMetaSellerPage"),
        },
      ],
    },
    {
      path: "/seller",
      component: () => import("@/layouts/full-layout/Layout"),
      children: [
        {
          name: "SellerList",
          path: "sellerList",
          component: () => import("@/views/seller/SellerListPage"),
        },
        {
          name: "CreateSeller",
          path: "createSeller",
          component: () => import("@/views/seller/CreateEditSellerPage"),
        },
        {
          name: "EditSeller",
          path: "editSeller/:id",
          component: () => import("@/views/seller/CreateEditSellerPage"),
        },
        {
          name: "DetailsSeller",
          path: "detailsSeller/:id",
          component: () => import("@/views/seller/DetailsSellerPage"),
        },
      ],
    },
  ],
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }
  next();
});

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
